import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";

export default function* chargePeriod(action: ActionInterface): any {
  try {
    const res = yield call(Http.post, `charge/period`, action.payload);

    if (action.hasOwnProperty("onSuccess")) {
      action.onSuccess.call(this, res.data?.data);
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_AGENCY_FEE_CREATE_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchChargePeriod() {
  yield takeEvery(Constants.GLOBAL_CHARGE_PERIOD, chargePeriod);
}
